import {useContext} from 'solid-js'
import ReduxContext from './ReduxContext'

export const useRedux = () => {
    const context = useContext(ReduxContext)
    if (!context) {
        throw new Error(
            'could not find redux context value; please ensure the component is wrapped in a <ReduxProvider>'
        )
    }
    return context
}
